export const SET_DEVICE_INFO = "SET_DEVICE_INFO";
export const FETCH_DEVICE_SYSTEM_ID_REQUEST = "FETCH_DEVICE_SYSTEM_ID_REQUEST";
export const FETCH_DEVICE_SYSTEM_ID_SUCCESS = "FETCH_DEVICE_SYSTEM_ID_SUCCESS";
export const FETCH_DEVICE_SYSTEM_ID_FAILURE = "FETCH_DEVICE_SYSTEM_ID_FAILURE";
